import { render, staticRenderFns } from "./subs-item-single.vue?vue&type=template&id=2cd31316&"
import script from "./subs-item-single.vue?vue&type=script&lang=js&"
export * from "./subs-item-single.vue?vue&type=script&lang=js&"
import style0 from "./subs-item-single.vue?vue&type=style&index=0&id=2cd31316&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports